var B64={alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",lookup:null,ie:/MSIE /.test(navigator.userAgent),ieo:/MSIE [67]/.test(navigator.userAgent),encode:function(e){var t,n,i,r=B64.toUtf8(e),o=-1,a=r.length,s=[,,,];if(B64.ie){for(var u=[];++o<a;)t=r[o],n=r[++o],s[0]=t>>2,s[1]=(3&t)<<4|n>>4,isNaN(n)?s[2]=s[3]=64:(i=r[++o],s[2]=(15&n)<<2|i>>6,s[3]=isNaN(i)?64:63&i),u.push(B64.alphabet.charAt(s[0]),B64.alphabet.charAt(s[1]),B64.alphabet.charAt(s[2]),B64.alphabet.charAt(s[3]));return u.join("")}for(var u="";++o<a;)t=r[o],n=r[++o],s[0]=t>>2,s[1]=(3&t)<<4|n>>4,isNaN(n)?s[2]=s[3]=64:(i=r[++o],s[2]=(15&n)<<2|i>>6,s[3]=isNaN(i)?64:63&i),u+=B64.alphabet[s[0]]+B64.alphabet[s[1]]+B64.alphabet[s[2]]+B64.alphabet[s[3]];return u},decode:function(e){if(e.length%4)throw new Error("InvalidCharacterError: 'B64.decode' failed: The string to be decoded is not correctly encoded.");var t=B64.fromUtf8(e),n=0,i=t.length;if(B64.ieo){for(var r=[];i>n;)t[n]<128?r.push(String.fromCharCode(t[n++])):t[n]>191&&t[n]<224?r.push(String.fromCharCode((31&t[n++])<<6|63&t[n++])):r.push(String.fromCharCode((15&t[n++])<<12|(63&t[n++])<<6|63&t[n++]));return r.join("")}for(var r="";i>n;)r+=t[n]<128?String.fromCharCode(t[n++]):t[n]>191&&t[n]<224?String.fromCharCode((31&t[n++])<<6|63&t[n++]):String.fromCharCode((15&t[n++])<<12|(63&t[n++])<<6|63&t[n++]);return r},toUtf8:function(e){var t,n=-1,i=e.length,r=[];if(/^[\x00-\x7f]*$/.test(e))for(;++n<i;)r.push(e.charCodeAt(n));else for(;++n<i;)t=e.charCodeAt(n),128>t?r.push(t):2048>t?r.push(t>>6|192,63&t|128):r.push(t>>12|224,t>>6&63|128,63&t|128);return r},fromUtf8:function(e){var t,n=-1,i=[],r=[,,,];if(!B64.lookup){for(t=B64.alphabet.length,B64.lookup={};++n<t;)B64.lookup[B64.alphabet.charAt(n)]=n;n=-1}for(t=e.length;++n<t&&(r[0]=B64.lookup[e.charAt(n)],r[1]=B64.lookup[e.charAt(++n)],i.push(r[0]<<2|r[1]>>4),r[2]=B64.lookup[e.charAt(++n)],64!=r[2])&&(i.push((15&r[1])<<4|r[2]>>2),r[3]=B64.lookup[e.charAt(++n)],64!=r[3]);)i.push((3&r[2])<<6|r[3]);return i}},base64_encode=function(e){return B64.encode(e)},base64_decode=function(e){return B64.decode(e)};
if (!btoa) btoa = B64.encode;
if (!atob) atob = B64.decode;

if (!Date.now) {
	Date.now = function() { return new Date().getTime(); };
}

function getQueryParam(name, url) {
	return (match = RegExp('[?&]' + name + '=([^&]*)').exec(url || window.location.search)) && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

Number.prototype.currency = function(c, d, t) {
	var n = this,
		c = isNaN(c = Math.abs(c)) ? 2 : c,
		d = d || ".",
		t = t || ",",
		s = n < 0 ? "-" : "",
		i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
		j = (j = i.length) > 3 ? j % 3 : 0;
	return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

$.fn.scrollTo = function(target, options) {
	if (!(target = $(target)).length) return false;

	options = $.extend({}, {
		offset:   0,
		callback: null
	}, options);

	this.stop();

	return this.animate({scrollTop: target.offset().top + options.offset}, {
		duration: 500, complete: function(e) {
			if (typeof options.callback == 'function') {
				options.callback(e);
			}
		}
	});
};

$.fn.getVal = function(name) {
	var $e = this.find('[data-name="' + name + '"]');

	switch ($e.attr('type')) {
		case 'radio':
			return $e.filter(':checked').val() || '';

		case 'checkbox':
			var vals = [];
			$e.filter(':checked').each(function() {
				vals.push($(this).val());
			});
			return vals;

		default:
			return $e.val() || '';
	}
};

buildDtxIframe = function() {
	var $form = $('form').first(),
		$iframe = $('<iframe id="dtx" src="http://framein.1800carshow.com/?gid=0000-4134&formpath=used"></iframe>'),
		$backButton = $('<a id="dtx-back" href="#" onclick="location.reload()">Back</a>');
	$form.append($iframe);
	$form.append($backButton);
	$iframe.hide();
	$backButton.hide();
}

showDtxIframe = function() {
	// For this to work, you have to have called `buildDtxIframe` at some point
	var $form = $('form').first(),
		$iframe = $('iframe#dtx'),
		$backButton = $('a#dtx-back');
	$form.children().hide();
	$iframe.height(500);
	$iframe.css('width', '100%');
	$iframe.css('overflow', 'hidden');
	$iframe.show();
	$backButton.show();
};
